<template>
  <main>
    <HeaderMain type="-fluid" />

    <section class="c-section c-section--panel position-relative">
      <nav class="c-nav bg-white d-lg-none">
        <div class="c-container-fluid">
          <ul class="ul-reset d-flex">
            <li class="c-nav__item active me-3">
              <router-link to="/" class="d-block">Mis cursos</router-link>
            </li>
            <li class="c-nav__item me-3">
              <router-link to="/membresia" class="d-block">Mi membresía</router-link>
            </li>
            <li v-if="isTeacherUser" class="c-nav__item">
              <router-link to="/ingresos" class="d-block">Mis ingresos</router-link>
            </li>
          </ul>
        </div>
      </nav>
      <section class="d-flex">
        <section>
          <aside class="c-sidebar-container d-none d-lg-block">
            <section class="c-sidebar bg-white py-4">
              <div class="c-profile-card mb-4">
                <div class="c-container-fluid">
                  <div class="d-flex flex-column justify-content-center
                    align-items-center">

                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton
                          type="avatar"
                          no-aspect
                          animation="fade"
                          width="95px"
                          height="95px"
                          class="light mb-2"
                        ></b-skeleton>
                        <b-skeleton
                          no-aspect
                          animation="fade"
                          class="light mb-2"
                        ></b-skeleton>
                      </template>

                      <figure class="c-profile-card__avatar c-avatar mb-2 position-relative">
                        <div
                          v-if="hasBadge"
                          class="c-avatar__badge bg-pri-color rounded white position-absolute
                            d-flex justify-content-center align-items-center"
                        >
                          <i
                            v-if="userData.roles.includes('team')
                              || userData.roles.includes('education')
                              || userData.roles.includes('core')
                              || userData.roles.includes('agent')"
                            class="d-flex align-items-center iconf-user fs-14"></i>
                          <i
                            v-else-if="userData.roles.includes('teacher')
                              || userData.roles.includes('teacher-pro')"
                            class="d-flex align-items-center iconf-graduation-cap fs-14"></i>
                          <i
                            v-else-if="isAdminUser"
                            class="d-flex align-items-center iconf-config fs-14"></i>
                          <i
                            v-else-if="userData.membership"
                            class="d-flex align-items-center iconf-king fs-14"></i>
                        </div>
                        <img class="w-100 h-100 of--cover" :src="userData.photo" alt="">
                      </figure>
                      <h2 class="c-profile-card__name text-center fs-18 w-bold mb-1 darks">
                        {{ userData.first_name }}
                        {{ userData.last_name }}
                      </h2>
                      <p
                        v-if="academicUser"
                        class="w-sbold d-flex justify-content-center
                        align-items-center dark-gray fs-14 mb-0">
                        <i class="iconf-graduation-cap d-flex align-items-center me-2 fs-21"></i>
                        {{ academicUser }}
                      </p>
                    </b-skeleton-wrapper>
                  </div>
                </div>
              </div>
              <nav class="c-nav bg-white">
                <div class="mb-4">
                  <ul class="ul-reset d-flex flex-column">
                    <li class="c-nav__item me-3 me-lg-0">
                      <router-link to="/" class="d-block">
                        Mis cursos
                      </router-link>
                    </li>
                    <li class="c-nav__item me-3 me-lg-0">
                      <router-link to="/membresia" class="d-block">
                        Mi membresía
                      </router-link>
                    </li>
                    <li v-if="isTeacherUser" class="c-nav__item">
                      <router-link to="/ingresos" class="d-block">
                        Mis ingresos
                      </router-link>
                    </li>
                  </ul>
                </div>

                <div class="mb-4">
                  <div class="c-hr bg-color-gray"></div>
                </div>

                <ul v-if="userData" class="ul-reset d-flex flex-column">
                  <li class="c-nav__item single">
                    <router-link
                      to="/editar"
                      class="d-flex align-items-center"
                    >
                      <i class="me-2 iconf-pen"></i>
                      Editar perfil
                    </router-link>
                  </li>
                </ul>
              </nav>
            </section>
          </aside>
        </section>
        <section class="c-container-fluid py-3 py-lg-4 flex-grow-1">
          <router-view keep-alive />
        </section>
      </section>
    </section>
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      user: null,

      isLoading: true,
    };
  },
  components: {
    HeaderMain: () => import(/* webpackChunkName: "header-main" */'../components/Header.vue'),
  },
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
    }),

    isUserLoggedIn() {
      return this.userData && this.userData.id;
    },
    isUserSuscriber() {
      return this.isUserLoggedIn && this.userData.membership;
    },
    isAdminUser() {
      return (this.isUserLoggedIn)
        ? (this.userData.roles.includes('team')
            || this.userData.roles.includes('education')
            || this.userData.roles.includes('core')
            || this.userData.roles.includes('administrator')
            || this.userData.roles.includes('teacher')
            || this.userData.roles.includes('teacher-pro')
        )
        : false;
    },
    isTeacherUser() {
      return (this.isUserLoggedIn)
        ? (this.userData.roles.includes('teacher')
          || this.userData.roles.includes('teacher-pro')
        )
        : false;
    },

    hasBadge() {
      return this.isAdminUser || this.isUserSuscriber;
    },

    academicUser() {
      let role = '';

      if (this.isUserLoggedIn) {
        if (this.userData.roles.includes('student') || this.userData.membership) {
          role = 'Estudiante';
        } else if (this.userData.roles.includes('teacher') || this.userData.roles.includes('teacher-pro')) {
          role = 'Docente';
        }
      }

      return role;
    },
  },
  watch: {
    userData(data) {
      this.user = data;

      this.isLoading = false;
    },
  },
  mounted() {
    if (this.userData && this.userData.id) {
      this.user = this.userData;

      this.isLoading = false;
    }
  },
};
</script>
